// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1IRiQ","content":"LayoutSettings_content__1lJfC"};